import { PageTitle } from "app/components";
import PerfilConfig from "./PerfilConfig";

const PerfilConfigIndex = () => {
    const titles = [
        "Cadastro",
        { label: "Perfil", route: "/profile" },
        "Configuração",
    ];

    return (
        <div className="">
            <PageTitle titles={titles} />
            <PerfilConfig />
        </div>
    );
};

export default PerfilConfigIndex;
